import initMK from '../_core/init.js';
import checkObjectType from '../_helpers/checkobjecttype.js';
import matreshkaError from '../_helpers/matreshkaerror.js';
import assign from '../_helpers/assign.js';
import debounce from '../_helpers/debounce.js';
import forEach from '../_helpers/foreach.js';
import forOwn from '../_helpers/forown.js';
import addSource from './_addsource.js';
import createCalcHandler from './_createcalchandler.js';
import defineProp from '../_core/defineprop.js';
import removeListener from '../off/_removelistener.js';
import removeTreeListener from '../off/_removetreelistener.js';
export default function calc(object, target, sources, givenHandler, eventOptions) {
  if (typeof this === 'object' && this.isMatreshka) {
    // when context is Matreshka instance, use this as an object and shift other args
    eventOptions = givenHandler;
    givenHandler = sources;
    sources = target;
    target = object;
    object = this;
  } else {
    // throw error when object type is wrong
    checkObjectType(object, 'calc');
  }
  if (target instanceof Object) {
    /*
     * accept an object
     * this.calc({target: { source, handler, event } }, commonEventOptions);
     */
    forOwn(target, function (_ref, itemTarget) {
      var itemSource = _ref.source,
        itemHandler = _ref.handler,
        itemEventOptions = _ref.event;
      var commonEventOptions = sources;
      var mergedEventOptions = {};
      if (commonEventOptions) {
        // extend event object by "global" event
        assign(mergedEventOptions, commonEventOptions);
      }
      if (itemEventOptions) {
        // extend event object by "local" event ("event" key of an object)
        assign(mergedEventOptions, itemEventOptions);
      }
      calc(object, itemTarget, itemSource, itemHandler, mergedEventOptions);
    });
    return object;
  }
  if (typeof target !== 'string') {
    throw matreshkaError('calc:target_type', {
      target: target
    });
  }
  eventOptions = eventOptions || {};
  var def = initMK(object);
  var _eventOptions = eventOptions,
    _eventOptions$setOnIn = _eventOptions.setOnInit,
    setOnInit = _eventOptions$setOnIn === void 0 ? true : _eventOptions$setOnIn,
    _eventOptions$debounc = _eventOptions.debounceCalcOnInit,
    debounceCalcOnInit = _eventOptions$debounc === void 0 ? false : _eventOptions$debounc,
    _eventOptions$debounc2 = _eventOptions.debounceCalc,
    debounceCalc = _eventOptions$debounc2 === void 0 ? true : _eventOptions$debounc2,
    _eventOptions$debounc3 = _eventOptions.debounceCalcDelay,
    debounceCalcDelay = _eventOptions$debounc3 === void 0 ? 0 : _eventOptions$debounc3,
    _eventOptions$isTarge = _eventOptions.isTargetPropertyHidden,
    isTargetPropertyHidden = _eventOptions$isTarge === void 0 ? false : _eventOptions$isTarge;
  var defaultHandler = function defaultHandler(value) {
    return value;
  };
  var handler = givenHandler || defaultHandler;
  var allSources = [];
  var syncCalcHandler = createCalcHandler({
    object: object,
    eventOptions: eventOptions,
    allSources: allSources,
    target: target,
    def: def,
    handler: handler
  });
  var debouncedCalcHandler;
  var calcHandler;
  if (debounceCalcOnInit || debounceCalc) {
    debouncedCalcHandler = debounce(syncCalcHandler, debounceCalcDelay);
  }
  defineProp(object, target, isTargetPropertyHidden);
  if (!Array.isArray(sources)) {
    sources = [sources];
  }
  if (debounceCalc) {
    // created above, since debounceCalc is on
    calcHandler = debouncedCalcHandler;
  } else {
    calcHandler = syncCalcHandler;
  }
  forEach(sources, function (source) {
    if (typeof source === 'string') {
      // source object is current object
      addSource({
        calcHandler: calcHandler,
        allSources: allSources,
        sourceKey: source,
        sourceObject: object,
        eventOptions: eventOptions
      });
    } else {
      // source object is external object
      if (!source || typeof source !== 'object') {
        throw matreshkaError('calc:source_type', {
          source: source
        });
      }
      var sourceKey = source.key;
      var sourceObject = source.object;
      if (Array.isArray(sourceKey)) {
        // many keys are passed
        forEach(sourceKey, function (sourceKeyItem) {
          addSource({
            calcHandler: calcHandler,
            allSources: allSources,
            sourceKey: sourceKeyItem,
            sourceObject: sourceObject,
            eventOptions: eventOptions
          });
        });
      } else {
        // one key is passed
        addSource({
          calcHandler: calcHandler,
          allSources: allSources,
          sourceKey: sourceKey,
          sourceObject: sourceObject,
          eventOptions: eventOptions
        });
      }
    }
  });
  // a hidden target belongs to one binding of the bindings parser, which removes the calc with the binding
  if (isTargetPropertyHidden) {
    def.props[target].removeCalc = function () {
      var _debouncedCalcHandler;
      forEach(allSources, function (_ref2) {
        var sourceKey = _ref2.sourceKey,
          sourceObject = _ref2.sourceObject,
          isDelegated = _ref2.isDelegated;
        if (isDelegated) {
          removeTreeListener(sourceObject, sourceKey, calcHandler);
        } else {
          removeListener(sourceObject, "_change:deps:" + sourceKey, calcHandler);
        }
      });
      (_debouncedCalcHandler = debouncedCalcHandler) == null || _debouncedCalcHandler.cancel();
      delete def.props[target];
    };
  }
  if (setOnInit) {
    if (debounceCalcOnInit) {
      // created above, since debounceCalcOnInit is on
      debouncedCalcHandler();
    } else {
      syncCalcHandler();
    }
  }
  return object;
}